import { DirectDebitFormController } from './directDebitForm.controller';
import template from './directDebitForm.html';

export const directDebitFormComponent = {
  name: 'directDebitComponent',
  restrict: 'E',
  template,
  controller: DirectDebitFormController,
  controllerAs: 'vm',
  bindings: {
    model: '=',
    form: '='
  }
};
